import {reqWithToken} from './requestHelper';


export async function removeFile(params){
    return await reqWithToken('api/upload', {
        method: 'Delete',
        params
    });
}

export async function download({key}){
    return (await reqWithToken('api/upload', {
        params:{key},
        responseType: 'blob'
    })).data;
}